import {Contact} from "./Contact";

export const CreateContact = `
    mutation createContact ($input: CreateContactInput!) {
        createContact (input: $input) {
            ${Contact}
        }
    }
`;
